import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as $ from 'jquery';

@Injectable()
export class ExcelServiceHeader {

  constructor() { }
      /*MÉTODO PARA EXPORTAR EN EXCEL*/
        public dataListaExport = [];
        public headers:Array<any>[];

        public exportXlsTableView = function(data, columnas, filename, datosHeader) {
            this.dataListaExport = this.formatJSONData(columnas, data);
            this.drawTable(this.dataListaExport, filename, datosHeader);
        };

        /*CREA UN NUEVO JSON EN BASE A LA INFORMACION DE colDef Y dataListaEventoOperador*/
        public formatJSONData = function(columns, data) {
            let i = 0;
            let lenght = 0;
            let str = "";
            this.headers = new Array<any>();
            let that = this;
            
            this.dataListaExport = [];
            columns.forEach(function(col) {
                let colString = "";
                //if (col.visible && col != 'sinDato' && col != 'Avance') {
                    let element = {field: "", name: "", display: ""};
                    element.field = col.tipoDato;
                    element.name = col.name;
                    element.display = col.display;
                    that.headers.push(element);
                //}

                /*if (!col.visible && col == 'Avance de Ruta') {
                    let element:any;
                    element.field = col;
                    element.name = col;
                    this.headers.push(element);
                }*/
            });

            data.forEach(function(evento) {
                let reg = '{';
                let colIndex = 0;



                columns.forEach(function(col) {
                    col = col.name;
                    if ((colIndex + 1) != columns.length) {
                        if (evento[col] != null && evento[col] != undefined) {
                            reg += "\"" + col + "\"" + ":" + "\"" + evento[col].toString().split('"').join('\'') + "\",";
                        } else {
                                reg += "\"" + col + "\"" + ":" + "\"" + "\",";
                        }
                    }
                    else {
                        if (evento[col] != null && evento[col] != undefined) {
                            reg += "\"" + col + "\"" + ":" + "\"" + evento[col].toString().split('"').join('\'') + "\"";
                        }
                        else {
                                reg += "\"" + col + "\"" + ":" + "\"" + "\"";
                        }
                    }
                    colIndex++;
                });

                if ((lenght + 1) != data.length && (lenght + 1) != 0) {
                    reg += "},";
                }
                else {
                    reg += "}";
                }
                str += reg;
                lenght++;
            });

            let jsonObj = $.parseJSON('[' + str + ']');
            return jsonObj;
        };

        /*CREA UN STRING QUE TENDRÁ EL FORMATO DE UNA TABLA HTML Y LUEGO LA CONVIERTE A TRAVÉS DEL PLUGIN*/
        public drawTable = function(data, filename, datosHeader) {
            let table = '<style>.textoCambio{mso-number-format:"\@"; } .text{ mso-number-format:"\@";/*force text*/} .num {mso-number-format:"0\.000";} </style> <meta http-equiv="Content-type" content="text/html; charset=utf-8" /> <table id="DataTable" cellspacing="0" cellpadding="0">'

            /*AGREGA LOS ENCABEZADOS*/

            let tablaTemp = ' <tr>' +
            '   <td colspan="@numColumnas" style="text-align: center;">@cliente</td>' +
            ' </tr>' +
            ' <tr>' +
            '   <td colspan="@numColumnas" style="text-align: center;">@rfc</td>' +
            ' </tr>' +
            ' <tr>' +
            '   <td colspan="@numColumnas" style="text-align: center;">@segundoTextoHeader</td>' +
            ' </tr>' +
            ' <tr>' +
            '   <td colspan="@numColumnas" style="text-align: center;">@tercerTextoHeader</td>' +
            ' </tr>' +
            ' <tr>' +
            '   <td colspan="@columnasDerecha" style="text-align: right;">@fechaHoraImpresion</td>' +
            ' </tr>' +
            ' <tr>' +
            '   <td colspan="@columnasDerecha" style="text-align: right;">@numeroPagina</td>' +
            ' </tr>';
            tablaTemp = tablaTemp.replace(/@numColumnas/g, this.headers.length + 2);
            tablaTemp = tablaTemp.replace(/@columnasDerecha/g, this.headers.length + 1);
            tablaTemp = tablaTemp.replace('@cliente', datosHeader.cliente);
            tablaTemp = tablaTemp.replace('@rfc', datosHeader.rfc);
            tablaTemp = tablaTemp.replace('@segundoTextoHeader', datosHeader.segundoTextoHeader);
            tablaTemp = tablaTemp.replace('@tercerTextoHeader', datosHeader.tercerTextoHeader);
            tablaTemp = tablaTemp.replace('@fechaHoraImpresion', datosHeader.fechaHoraImpresion);
            tablaTemp = tablaTemp.replace('@numeroPagina', datosHeader.numeroPagina);
            tablaTemp = tablaTemp.replace('@cantidadRegistros', data.lenght);
            table += tablaTemp;


            table += "<tr> <td></td>";
            let headersString = "";
            this.headers.forEach(function(header) {
                let head = header.display;          
                headersString += '<td style="text-align: center;font-size:21px;background-color: #C8C8C8;"><b>' + head + '</b></td>';
            });

            table += headersString + "</tr>";

            /*AGREGA LOS REGISTROS*/
            let index = 0;
            let that = this;
            var sumSubtotal = 0;
            var sumIVa = 0;
            var sumTotal = 0;
            data.forEach(function(row) {
                let dataRow = that.drawRow(index, row);
                sumSubtotal+= parseFloat(row.SUBTOTAL_BEFORE_TAX);
                sumIVa+= parseFloat(row.TOTAL_IVA);
                sumTotal+= parseFloat(row.TOTAL);
                table += dataRow;
            });

            table += "<tr><tr> <tr> <td></td><td>Cantidad de Registros: @cantidadRegistros</td> <td></td> <td></td> <td></td> <td></td> <td> @sumSubtotal</td> <td>@sumIVA</td> <td>@sumTotal</td> </tr>";

            table = table.replace('@cantidadRegistros', data.length);
            table = table.replace('@sumSubtotal', sumSubtotal.toFixed(2).toString());
            table = table.replace('@sumIVA', sumIVa.toFixed(2).toString());
            table = table.replace('@sumTotal', sumTotal.toFixed(2).toString());

            table += "</table>";

            var elem = document.createElement('div');
            elem.style.cssText = 'display:none;';
            elem.innerHTML = table;
            document.body.appendChild(elem);

            //document.getElementById("excelTable").innerHTML = table;

            let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            //let isFirefox = typeof InstallTrigger !== 'undefined';

            if (isSafari) {
                let blob = new Blob([table], { type: "application/vnd.ms-excel; charset=utf-8" });
                FileSaver.saveAs(blob, filename+'.xls');
            } else {
                let blob = new Blob([table], { type: "text/plain;charset=utf-8" });
                FileSaver.saveAs(blob, filename+'.xls');
            }
        };

        /*CREA UNA FILA EN LA TABLA EN BASE A LA INFORMACIÓN CORRESPONDIENTE AL json-dataEventoOperadorRow[i]*/
        public drawRow = function(i, dataRow) {
            let value;
            let row = "<tr> <td></td>";
            let that = this;

            this.headers.forEach(function(elem) {
                if (dataRow[elem.name] == undefined) {
                    value = '';
                }
                else {
                    value = dataRow[elem.name];
                }

                if(elem.field == "string"){                  
                  row += '<td>' + value + '</td>';
                }
                else
                {
                    if (elem.field == "forceNumber") {
                        row += '<td class="num">' + value + '</td>';
                    } else {
                        if (elem.field == "forceString"){                  
                            row += '<td class="text">' + value + '</td>';
                        }
                        else if(elem.field == "moneda")
                        {
                            row += '<td>$';
                            if (parseFloat(value).toFixed(2).toString() != 'NaN') {
                                    row += parseFloat(value).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + '</td>';
                            }
                            else {
                                    row += parseFloat("0").toFixed(2) + '</td>';
                            }
                        }
                        else{
                            row += '<td class="textoCambio">$';
                            if (parseFloat(value).toFixed(2).toString() != 'NaN') {
                                    row += parseFloat(value).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + '</td>';
                            }
                            else {
                                    row += parseFloat("0").toFixed(2) + '</td>';
                            }
                        }
                    }
                }
            });

            row += "</tr>";
            return row;
        };
}


// WEBPACK FOOTER //
// ./src/app/utils/excel.service.ts